<template>
  <!-- b -->
  <div class="container">
    <el-row style="height: 90%;">
      <el-col :span="12" class="left-content">
        <div class="company-name">{{userInfoMes.enterpriseName}}
          <el-popover
            placement="bottom"
            :width="80"
            trigger="hover"
          >
            <template #reference>
              <span style="font-size: 15px;cursor: pointer;color: #E7C478;">前往国行信E融 ></span>
            </template>
            <el-image fit="contain" style="height: 150px;width: 150px;" draggable="false" :src="qrGhxer"></el-image>
            <div style="text-align: center;">微信扫一扫前往</div>
          </el-popover>
        </div>
        <!-- 分数 -->
        <div class="score-content" >
          <span class="score-num">{{scoreTotal == -1 ? '数据加载中……' : scoreTotal}}</span><span style="font-size: 18px;color: #fff;" v-if="scoreLevel">信用分等级：{{scoreLevel}}</span>
        </div>
        <div>
          <p style="font-size: 24px;" v-if="scoreUnscramble.length>0||noConformityReasons">分数解读：</p>
          <p style="font-size: 16px;text-indent: 32px;" v-if="noConformityReasons">不符合原因： {{noConformityReasons}}</p>
          <p style="font-size: 16px;text-indent: 32px;" v-if="scoreUnscramble.length>0">建议您优先更新<span
              class="text-color-gold" v-for="(item, index) of scoreUnscramble"
              :key="item">{{index == scoreUnscramble.length-1 ? item : (item + '，')}}</span>部分相关内容，有助于提升行业水平。</p>
        </div>
        <div class="btn-content">
          <span class="btn-content-span" @click="handleChangeType('1')">查看E查工程对比<i class="el-icon-arrow-right"></i></span>
          <!--<span class="btn-content-span right-span" @click="handleChangeType('2')">查看工程信易贷评分<i class="el-icon-arrow-right"></i></span>-->
        </div>
      </el-col>
      <el-col :span="12">
        <div ref="chartone" element-loading-background="rgba(0, 0, 0, 0)" element-loading-text="数据加载中……" v-loading="loading" style="height: 100%;"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import * as echarts from 'echarts'
import {
  getCountryBankScoreByNameUrl,
  getCountryBankProposalByNameUrl
} from '@/api/query.js'
export default {
  name: 'b-score',
  data () {
    return {
      loading: true,
      noConformityReasons: '',
      scoreUnscramble: [],
      scoreTotal: -1,
      scoreLevel: '',
      scoreArr: [0, 0, 0, 0, 0],
      userInfoMes: {},
      qrGhxer: require('@/assets/images/qr_ghxyr.png')
    }
  },
  mounted () {
    const vm = this
    if (vm.userInfo) {
      vm.userInfoMes = JSON.parse(vm.userInfo)
      if (vm.userInfoMes.businessInformationStatus === '1') {
        vm.initScore()
        vm.initScoreUnscramble()
        // vm.initScoreArr()
      }
    }
  },
  computed: {
    ...mapGetters([
      'vipData', // 会员数据
      'idToken',
      'userInfo'
    ])
  },
  methods: {
    handleChangeType: function (e) {
      this.$emit('btnActive', e)
    },
    initScoreUnscramble () {
      const vm = this
      const data = {
        companyName: vm.userInfoMes.enterpriseName
      }
      getCountryBankProposalByNameUrl(data).then(result => {
        if (result.code === 0) {
          const res = result.data
          console.log(res)
          if (res.maintainPro) {
            const arr = res.maintainPro.split('、')
            vm.scoreUnscramble = arr
          }
          if (res.noConformityReasons) {
            vm.noConformityReasons = res.noConformityReasons
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    initScore () {
      const vm = this
      const data = {
        companyName: vm.userInfoMes.enterpriseName
      }
      getCountryBankScoreByNameUrl(data).then(result => {
        if (result.code === 0) {
          const obj = result.data.RetData
          const arr = []
          console.log(obj)
          // 顺序：信用分+创新分+运营分+行业实力分+企业背景分+交易分+总分
          const historyCreditScore = obj.creditHistory.enforcementScore +
            obj.creditHistory.mortgageScore +
            obj.creditHistory.judgementsScore +
            obj.creditHistory.taxHonorScore +
            obj.creditHistory.inspectionScore +
            obj.creditHistory.constructionViolationsScore +
            obj.creditHistory.unusualScore +
            obj.creditHistory.otherViolationsScore
          // 创新
          const innovationAbility = obj.innovationAbility.patentScore +
            obj.innovationAbility.tradeMarkScore +
            obj.innovationAbility.softwareCopyrightScore
          // 运营
          const operationSituation = obj.operationSituation.nearlyYearAmountScore +
            obj.operationSituation.nearlyYearNumScore +
            obj.operationSituation.recruitmentScore +
            obj.operationSituation.nearlyThreeYearNumScore +
            obj.operationSituation.nearlyThreeYearAmountScore +
            obj.operationSituation.increaseRateScore
          // 行业
          const industryStrength = obj.industryStrength.technicianScore +
            obj.industryStrength.honorScore +
            obj.industryStrength.qualityScore
          // 企业背景
          const enterpriseBackground = obj.enterpriseBackground.registrationTypeScore +
            obj.enterpriseBackground.realCapitalScore +
            obj.enterpriseBackground.operatingYearsScore
          // 履约
          const innovationAbilityScore = obj.trade.tradeNumScore +
            obj.trade.tradeAmountScore +
            obj.trade.tradeDelayScore

          if (historyCreditScore < 0) {
            arr.push(0)
          } else {
            arr.push(historyCreditScore)
          }
          if (innovationAbility < 0) {
            arr.push(0)
          } else {
            arr.push(innovationAbility)
          }
          if (operationSituation < 0) {
            arr.push(0)
          } else {
            arr.push(operationSituation)
          }
          if (industryStrength < 0) {
            arr.push(0)
          } else {
            arr.push(industryStrength)
          }
          if (enterpriseBackground < 0) {
            arr.push(0)
          } else {
            arr.push(enterpriseBackground)
          }
          if (innovationAbilityScore < 0) {
            arr.push(0)
          } else {
            arr.push(innovationAbilityScore)
          }
          vm.scoreArr = arr
          let level = ''
          if (obj.score <= 1) {
            level = 'C'
          } else if (obj.score > 1 && obj.score <= 100) {
            level = 'CC'
          } else if (obj.score > 100 && obj.score <= 200) {
            level = 'CCC'
          } else if (obj.score > 200 && obj.score <= 300) {
            level = 'B'
          } else if (obj.score > 300 && obj.score <= 400) {
            level = 'BB'
          } else if (obj.score > 400 && obj.score <= 500) {
            level = 'BBB'
          } else if (obj.score > 500 && obj.score <= 700) {
            level = 'A'
          } else if (obj.score > 700 && obj.score <= 900) {
            level = 'AA'
          } else if (obj.score > 900) {
            level = 'AAA'
          }
          vm.scoreTotal = obj.score
          vm.scoreLevel = level
          vm.initEchart()
        }
      }).catch(error => {
        console.log(error)
      })
    },
    initEchart: function () {
      const vm = this
      const option = {
        grid: {
          right: '100',
          containLabel: true
        },
        backgroundColor: 'rgba(255, 255, 255, 0)',
        radar: {
          center: ['50%', '50%'],
          radius: ['0', '130'],
          nameGap: 10,
          name: {
            textStyle: {
              color: '#fff',
              fontSize: 16,
              fontWeight: 600
            }
          },
          startAngle: 120,
          splitNumber: 1, // 统计图几层
          splitArea: {
            areaStyle: {
              color: ['rgba(0, 0, 0, 0)'], // 每层级颜色
              shadowColor: 'rgba(0, 0, 0, 0)', // 阴影颜色
              shadowBlur: 10
            }
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)' // 对角线颜色
            }
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)' // 圈线颜色
            }
          },
          indicator: [{
            name: '信用历史',
            max: 100
          },
          {
            name: '创新能力',
            max: 50
          },
          {
            name: '运营情况',
            max: 400
          },
          {
            name: '行业实力',
            max: 300
          },
          {
            name: '企业背景',
            max: 450
          },
          {
            name: '交易履约情况',
            max: 200
          }]
        },
        series: [{
          name: '信用分',
          type: 'radar',
          symbol: 'circle',
          areaStyle: {
            opacity: 0.5,
            color: new echarts.graphic.RadialGradient(0.5, 0.5, 0.5, [{
              color: 'rgba(255, 255, 255,0.3)', // 统计图内背景颜色
              offset: 0
            }])
          },
          itemStyle: {
            normal: {
              color: 'rgba(231, 196, 120, 0)', // 改变折线点的颜色
              lineStyle: {
                color: 'rgba(231, 196, 120, 1)' // 改变折线颜色
              }
            }
          },
          data: [{
            value: vm.scoreArr,
            name: '信用分'
          }]
        }]
      }
      var myChart = echarts.init(this.$refs.chartone)
      myChart.setOption(option)
    }
  }
}
</script>

<style scoped="scoped" lang="less">
  .left-content {
    text-align: left;
    color: #fff;
    display: flex;
    justify-content: flex-start;
    align-content: space-between;
    flex-wrap: wrap;

    .company-name {
      font-size: 30px;
    }

    .score-content {
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      width: 100%;
      .score-num {
        font-size: 60px;
        color: #E7C478;
        display: block;
        height: 40px;
        line-height: 40px;
        margin-right: 20px;
      }
    }

    .text-color-gold {
      color: #E7C478;
    }

    .btn-content {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .btn-content-span {
        width: 230px;
        height: 50px;
        line-height: 50px;
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        display: block;
        text-align: center;
      }

      .right-span {
        margin-left: 20px;
      }

      .btn-content-span:hover {
        background-color: #E7C478;
        color: #5D6FE9;
      }
    }
  }
</style>
